import { Direction } from '~common/model/basics';

export const changeDirection = (direction: Direction): number => {
  switch (direction) {
    case Direction.Down:
      return 90;
    case Direction.Left:
      return 180;
    case Direction.Up:
      return 270;
    default:
      return 0;
  }
};

export const getRotation = (rotation: number): string => {
  return `rotate(${rotation})`;
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/ui/icon/caret.helper.ts